(() => {
    'use strict';

    const forms = document.querySelectorAll('form.needs-validation');

    const updateFieldState = (el) => {
        if (!el || typeof el.checkValidity !== 'function') return;

        // optional: nur Inputs/Selects/Textareas
        if (!['INPUT', 'SELECT', 'TEXTAREA'].includes(el.tagName)) return;

        const valid = el.checkValidity();
        el.classList.toggle('is-valid', valid);
        el.classList.toggle('is-invalid', !valid);
    };

    forms.forEach((form) => {

        // Mark field as touched on first interaction
        form.addEventListener('focusin', (event) => {
            const el = event.target;
            if (el && el.closest('form') === form) {
                el.dataset.touched = '1';
            }
        }, true);

        // Live validation on input/change if touched
        const liveHandler = (event) => {
            const el = event.target;
            if (!el || el.dataset.touched !== '1') return;
            updateFieldState(el);
        };

        form.addEventListener('input', liveHandler, true);
        form.addEventListener('change', liveHandler, true);

        // On submit: block + show feedback (Bootstrap default)
        form.addEventListener('submit', (event) => {
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            }
            form.classList.add('was-validated');

            // Optional: force update on all fields at submit
            form.querySelectorAll('input, select, textarea').forEach(updateFieldState);
        }, false);

    });
})();
